<template>
  <div class="font-size-container">
    <!-- 字体大小选择控件 -->
    <div class="font-size-controls">
<!--      <span class="label">字体大小：</span>-->
      <button
          v-for="option in sizeOptions"
          :key="option.value"
          @click="setFontSize(option.value)"
          :class="{ active: currentSize === option.value }"
          class="font-size-btn"
      >
        {{ option.label }}
      </button>
    </div>

    <!-- 内容区域（通过padding-top避免内容被遮挡） -->
    <div class="content-container" :class="currentSize">
      <slot></slot>
    </div>
  </div>
</template>

<script>

export default {
  name: 'FixedFontSizeSelector',
  data() {
    return {
      currentSize: 'small',
      sizeOptions: [
        { value: 'small', label: this.$t("studentProgramme.small") },
        { value: 'medium', label: this.$t("studentProgramme.medium") },
        { value: 'large', label: this.$t("studentProgramme.large") }
      ]
    }
  },
  mounted() {
    const savedSize = localStorage.getItem('fontSize')
    if (savedSize && this.sizeOptions.some(opt => opt.value === savedSize)) {
      this.currentSize = savedSize
    }
  },
  methods: {
    setFontSize(size) {
      this.currentSize = size
      localStorage.setItem('fontSize', size)
    }
  }
}
</script>

<style scoped>
/* 容器样式 */
.font-size-container {
  position: relative;
  width: 100%;
}
/* 固定在顶部的控制栏 */
.font-size-controls {
  position: fixed;
  top: 0px;
  right: 0;
  padding: 8px 15px;
  backdrop-filter: blur(5px); /* 毛玻璃效果 */
  z-index: 7;
  display: flex;
  align-items: center;
  gap: 10px;
}
/* 小屏手机优化（≤ 480px） */
@media (max-width: 480px) {
  .font-size-controls {
    display: none;
  }
}
.label {
  font-size: 0.9rem;
  color: #666;
}

/* 按钮样式 */
.font-size-btn {
  padding: 4px 12px;
  border: 1px solid #ddd;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 15px;
  cursor: pointer;
  transition: all 0.2s;
  font-size: 0.85rem;
}

.font-size-btn:hover {
  background: rgba(240, 240, 240, 0.9);
}

.font-size-btn.active {
  background: #ffb842;
  color: black;
  border-color: #c0811f;
}

/* 使用深度选择器影响所有嵌套内容 */
.content-container.small480 ::v-deep * {
  font-size: 0.275rem;
}
.content-container.small ::v-deep * {
  font-size: 1.125rem;
}

.content-container.medium ::v-deep * {
  font-size: 1.375rem;
}

.content-container.large ::v-deep * {
  font-size: 1.875rem;
}

/* 添加过渡效果 */
.content-container ::v-deep * {
  transition: font-size 0.3s ease;
}
</style>